import { render, staticRenderFns } from "./LicenseSelectField.vue?vue&type=template&id=a1cda032&scoped=true"
import script from "./LicenseSelectField.vue?vue&type=script&lang=ts"
export * from "./LicenseSelectField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cda032",
  null
  
)

export default component.exports